/**
 * from @nike/eds with modifications to make it fullly controlled component
 */
import React from 'react';
import classNames from 'classnames';

interface ToggleProps extends React.HTMLAttributes<HTMLInputElement> {
  /** Unique ID for every checkbox */
  id: string;
  /** Synthetic event which runs when value changes, please refer to React docs for more information: https://reactjs.org/docs/events.html */
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  /** Boolean value to disable checkbox */
  disabled?: boolean;
  /** Boolean value of the checked state, to be updated with onChange */
  checked?: boolean;
  /** Upon form submission, value is the data submitted with the toggle's name */
  value?: string;
  /** Label text which describes the checkbox */
  label: string;
  /** Sets the size of the toggle button */
  size?: 'medium' | 'large';
}

export const Toggle: React.FC<ToggleProps> = ({
  id,
  onChange,
  disabled = false,
  className,
  checked,
  label,
  value = 'true',
  size = 'medium',
  children,
  ...rest
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled !== true) {
      if (onChange) onChange(event);
    }
  };

  const containerClass = classNames(className, `eds-toggle`, {
    [`eds-toggle--${size}`]: size !== 'medium',
    'eds-toggle--disabled': disabled,
  });

  return (
    <label htmlFor={id} className={containerClass}>
      <input
        id={id}
        type='checkbox'
        className='eds-toggle__input'
        onChange={handleChange}
        checked={checked}
        disabled={disabled}
        value={value}
        {...rest}
      />
      <span className='circle' />
      {label}
    </label>
  );
};
